import { useCallback } from "react";

export const useStripHtml = () => {
  const stripHtml = useCallback(
    (message) => message.replace(/<[^>]*>/g, "").trim() || null,
    []
  );

  return stripHtml;
};
